import React from 'react'

export const Warning = props => <svg aria-hidden='true' stroke= 'none' width="33" height="29" viewBox="0 0 33 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18 18H15V12H18V18ZM18 24H15V21H18V24ZM0 28.5H33L16.5 0L0 28.5Z" fill="#FFD440"/>
    <rect x="15" y="12" width="3" height="6" fill="#1A1A1A"/>
    <rect x="15" y="21" width="3" height="3" fill="#1A1A1A"/>
</svg>